/**
 * Central Google Business Profile configuration.
 * Single source of truth for ALL Google Maps / Reviews / Directions URLs across the site.
 *
 * Place ID: ChIJw442ZgPJD4gRk8V6dYznlw8 (verified, name: 2A Electronics Service, 5.0★)
 * Backend equivalent: GOOGLE_PLACE_ID in /app/backend/.env
 */

export const GOOGLE_PLACE_ID = 'ChIJw442ZgPJD4gRk8V6dYznlw8';

export const GOOGLE_BUSINESS = {
  placeId: GOOGLE_PLACE_ID,
  name: '2A Electronics Service',
  address: '4859 W Irving Park Rd, Chicago, IL 60641',
  phone: '(773) 766-5814',
  phoneRaw: '7737665814',
  timeZone: 'America/Chicago',
  businessHours: {
    Mon: [600, 1080], Tue: [600, 1080], Wed: [600, 1080],
    Thu: [600, 1080], Fri: [600, 1080], Sat: [600, 960], Sun: null,
  },
  lat: 41.9539,
  lng: -87.7481,

  // Direct link to your Google Business Profile (Maps listing)
  profileUrl: `https://www.google.com/maps/search/?api=1&query=2A+Electronics+Service&query_place_id=${GOOGLE_PLACE_ID}`,

  // "Write a review" deep link, opens Google's native review form
  reviewUrl: `https://search.google.com/local/writereview?placeid=${GOOGLE_PLACE_ID}`,

  // "Get directions" deep link, opens Google Maps with directions to your store
  directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=4859+W+Irving+Park+Rd,+Chicago,+IL+60641&destination_place_id=${GOOGLE_PLACE_ID}`,

  // Embeddable map (iframe src), uses the verified Place ID
  embedUrl: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.8!2d-87.7503!3d41.9539!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fcf96661e0ec3%3A0xf97e78c757ac9b93!2s4859%20W%20Irving%20Park%20Rd%2C%20Chicago%2C%20IL%2060641!5e0!3m2!1sen!2sus`,
};

export default GOOGLE_BUSINESS;
